export const ACTIONS = {
    STORE_LUMINARY_THUMBNAIL: 'STORE_LUMINARY_THUMBNAIL',
    CLEAR_LUMINARY_THUMBNAIL: 'CLEAR_LUMINARY_THUMBNAIL',
};

export type LuminaryThumbnail = {
    id: number;
    previewCanvas: HTMLCanvasElement;
};
